module.exports = __webpack_public_path__ + "img/chapel.071e7416.png";